import { CampaignLeadCost } from "@/api/campaign.api";
import { type CreditsResponse } from "@/api/credits.api";

export function getCreditStats(credits: CreditsResponse) {
  const totalMonthlyCredits =
    credits.baseCreditsPerMonth + credits.extraCreditsPerMonth;

  const creditsNeededRestOfPeriod = Math.max(
    0,
    credits.creditEstimateRestOfPeriod - credits.creditsRemaining,
  );

  const creditsNeededNextPeriod = Math.max(
    0,
    credits.creditEstimateNextPeriod - totalMonthlyCredits,
  );

  const creditEstimateRestOfPeriodExceeded = !!creditsNeededRestOfPeriod;

  const creditEstimateNextPeriodExceeded = !!creditsNeededNextPeriod;

  return {
    totalMonthlyCredits,
    creditsNeededRestOfPeriod,
    creditsNeededNextPeriod,
    creditEstimateRestOfPeriodExceeded,
    creditEstimateNextPeriodExceeded,
  };
}

export function getCampaignUpdateCreditStats({
  credits,
  campaignLeadCost,
  updatedCampaignLeadCost,
}: {
  credits: CreditsResponse;
  campaignLeadCost: CampaignLeadCost;
  updatedCampaignLeadCost: CampaignLeadCost;
}) {
  const {
    creditEstimateRestOfPeriod,
    creditEstimateNextPeriod,
    creditsRemaining,
  } = credits;

  const {
    totalMonthlyCredits,
    creditsNeededRestOfPeriod,
    creditsNeededNextPeriod,
    creditEstimateRestOfPeriodExceeded,
    creditEstimateNextPeriodExceeded,
  } = getCreditStats(credits);

  const updatedCreditEstimateRestOfPeriod =
    creditEstimateRestOfPeriod -
    campaignLeadCost.creditEstimateRestOfPeriod +
    updatedCampaignLeadCost.creditEstimateRestOfPeriod;

  const updatedCreditEstimateNextPeriod =
    creditEstimateNextPeriod -
    campaignLeadCost.creditEstimateNextPeriod +
    updatedCampaignLeadCost.creditEstimateNextPeriod;

  const updatedCreditsNeededRestOfPeriod = Math.max(
    0,
    updatedCreditEstimateRestOfPeriod - creditsRemaining,
  );

  const updatedCreditsNeededNextPeriod = Math.max(
    0,
    updatedCreditEstimateNextPeriod - totalMonthlyCredits,
  );

  const updatedCreditEstimateRestOfPeriodExceeded =
    !!updatedCreditsNeededRestOfPeriod;

  const updatedCreditEstimateNextPeriodExceeded =
    !!updatedCreditsNeededNextPeriod;

  return {
    totalMonthlyCredits,
    creditEstimateRestOfPeriod,
    creditEstimateNextPeriod,
    creditsNeededRestOfPeriod,
    creditsNeededNextPeriod,
    creditEstimateRestOfPeriodExceeded,
    creditEstimateNextPeriodExceeded,
    updatedCreditEstimateRestOfPeriod,
    updatedCreditEstimateNextPeriod,
    updatedCreditsNeededRestOfPeriod,
    updatedCreditsNeededNextPeriod,
    updatedCreditEstimateRestOfPeriodExceeded,
    updatedCreditEstimateNextPeriodExceeded,
  };
}
